import { render, staticRenderFns } from "./DayOfWeekForm.vue?vue&type=template&id=a085c952&scoped=true&lang=pug&"
import script from "./DayOfWeekForm.vue?vue&type=script&lang=js&"
export * from "./DayOfWeekForm.vue?vue&type=script&lang=js&"
import style0 from "./DayOfWeekForm.vue?vue&type=style&index=0&id=a085c952&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a085c952",
  null
  
)

export default component.exports